import useLocale from "../hooks/useLocale";
import { useNavigate } from "react-router-dom";
import { ComponentContainer, LayoutGrid } from "../components/LayoutContainers";
import { setTheme } from "../utils/utils";

setTheme("light");

const localeMap = {
    es: {
        title: "Página no encontrada",
        paragraph: "Lo sentimos, la página que estás buscando no existe o ya no se encuentra disponible.",
        cta: {
            text: "Volver atrás",
        },
    },
    en: {
        title: "Page not found",
        paragraph: "We're sorry, the page you're looking for doesn't exist or is no longer available.",
        cta: {
            text: "Go back",
        },
    },
};

export default function Error404Page() {
    const locale = useLocale();
    const navigate = useNavigate();

    return (
        <ComponentContainer image={`${window._env_.STATIC_HOST}/static/website/images/bg-cotizaciones.jpg`} classNames="error-page">
            <LayoutGrid spacingTop="10" spacingBottom="0" cols={1}>
                <section className="only-text component --theme-light --content-center ">
                    <div className="content">
                        <div className="text-content">
                            <div className="tag">
                                <img src={`${window._env_.STATIC_HOST}/static/website/images/icons/icon-arrow-left.svg`} alt="" />
                                Error 404
                                <img src={`${window._env_.STATIC_HOST}/static/website/images/icons/icon-arrow-right.svg`} alt="" />
                            </div>

                            <h2 className="title-hero">{localeMap[locale].title}</h2>
                            <p className="paragraph-hero">{localeMap[locale].paragraph}</p>
                        </div>
                        <button onClick={() => navigate(-2)} className="btn btn-primary" aria-label="home link">
                            {localeMap[locale].cta.text}
                        </button>
                    </div>
                </section>
            </LayoutGrid>
        </ComponentContainer>
    );
}
